import { CostItem } from "./common.types";
import { OrderResponse } from "./order.types";
import { CustomerResponse, PlaceResponse } from "./responses.type";

export enum VehicleStopType {
  CUSTOMER = "CUSTOMER",
  HUB = "HUB",
  WAREHOUSE = "WAREHOUSE",
  TRANSSHIPMENT = "TRANSSHIPMENT",
  UNRELATED = "UNRELATED",
  UNKNOWN = "UNKNOWN",
  PICKUP = "PICKUP",
}

export enum VehicleStopPurpose {
  DROP_OFF = "DROP_OFF",
  PICKUP = "PICKUP",
  REST = "REST",
  GENERAL = "GENERAL",
  UNKNOWN = "UNKNOWN",
  UNRELATED = "UNRELATED",
}

export interface TripResponse {
  tripId: number;
  plannedDate?: Date;
  startDateTime?: Date;
  plannedMiles?: number;
  actualMiles?: number;
  plannedReturnMiles?: number;
  actualReturnMiles?: number;
  plannedReturnDateTime?: Date;
  actualReturnDateTime?: Date;
  isRoundTrip?: boolean;
  status?: string;
  returnCalculationSource?: string;
  calculationAlgorithm?: string;
  syncSession?: string;
  courierId?: number;
  courier?: CourierResponse;
  vehicleId?: number;
  vehicle?: VehicleResponse;
  externalId?: string;
  externalSource?: string;
  additionalData?: any;
  shipperId?: number;
  tripStops: TripStopResponse[];
  vehicleStops?: VehicleStopResponse[];
}

export interface FetchTripsResponse {
  vehicleTrips: VehicleResponse[];
  unassignedTrips: TripResponse[];
  unassignedStops: TripStopResponse[];
}

export interface VehicleTripResponse {
  vehicleTripId: number;
  vehicleId: number;
  associatedDate: string;
  startedAt: Date;
  vehicleStops: VehicleStopResponse[];
  segments: VehicleTripSegmentResponse[];
  miles: number;
  duration: number;
  additionalData?: any;
  vehicle?: VehicleResponse;
  trips?: TripResponse[];
}

export interface TripStopResponse {
  tripStopId: number;
  plannedArrivalDateTime?: Date;
  plannedDepartureDateTime?: Date;
  actualArrivalDateTime?: Date;
  actualDepartureDateTime?: Date;
  status?: string;
  placeId?: number;
  place?: PlaceResponse;
  courierHasArrived?: boolean;
  tripId?: number;
  plannedTimeWindow?: string;
  externalId?: string;
  orders?: OrderResponse[];
  label?: string;
  customer?: CustomerResponse;
  additionalData?: any;
}

export interface CourierResponse {
  courierId?: number;
  email?: string;
  firstName?: string;
  lastName?: string;
  phoneNumber?: string;
  homeAddress?: string;
  drivingLicenseNumber?: string;
  photoUrl?: string;
  qrCode?: string;
  courierType?: string;
  shipperId: number;
  externalId?: string;
  externalSource?: string;
  additionalInfo?: any;
  costs?: Record<string, CostItem>;
}

export interface VehicleResponse {
  vehicleId?: number;
  vehicleType?: string;
  licensePlate?: string;
  model?: string;
  color?: string;
  capacity?: number;
  shipperId: number;
  externalId?: string;
  externalSource?: string;
  costs?: Record<string, CostItem>;
}
export interface VehicleTripSegmentResponse {
  vehicleTripSegmentId?: number;
  vehicleId?: number;
  courierId?: number;
  dateStart?: Date;
  dateEnd?: Date;
  associatedDate?: string;
  duration?: number;
  miles?: number;
  durationShare?: number;
  milesShare?: number;
  timeDrivenCost?: number;
  mileDrivenCost?: number;
  tripId?: number;
}

export interface VehicleStopMappingResponse {
  relatedEntity: string;
  relatedEntityId: number;
}

export interface VehicleStopResponse {
  vehicleStopId: number;
  vehicleId: number;
  courierId?: number;
  latitude: number;
  longitude: number;
  arrivedAt: Date;
  duration: number;
  type: VehicleStopType | null;
  purpose: VehicleStopPurpose | null;
  polyline: string;
  pathLength: number;
  dwellCost: number;
  transitShareCost: number;
  additionalData?: { stopLabel?: string };
  mapping?: VehicleStopMappingResponse[];
  tripStopIds?: number[];
  orders?: OrderResponse[];
}

export interface HasLatLong {
  latitude: number;
  longitude: number;
}

export interface TripTimelineItem {
  arrival?: Date;
  departure?: Date;
  pathLength?: number;
  duration?: number;
  stopNumber?: number;
  info: {
    title: string;
    purpose: string;
    type: string;
    address?: string;
    orders?: OrderResponse[];
    dwellCost?: number;
    transitCost?: number;
    allocatedCost?: number;
    vehicleStopId?: number;
  };
  location: HasLatLong;
  focused?: boolean;
  ref?: any;
  id?: number;
}

export interface TripStopLabelStruct {
  tripId: number;
  tripStopId: number;
  label: string;
}
